import React from 'react'
import { useTranslation } from 'react-i18next'
import Modal from '@ublique/components/LoadingModal'
import Button from '@ublique/components/Button'

const ModalSaveDocument = ({ open, close, data }) => {
  const { t } = useTranslation('Document')
  const { title, message, onDropEdits, onSaveDocument } = data

  const onDropEditsHandler = () => {
    Promise.resolve(onDropEdits?.()).then(close)
  }

  const onSaveDocumentHandler = () => {
    Promise.resolve(onSaveDocument?.()).then(close)
  }

  const footerCustom = () => {
    return (
      <>
        <Button kind='secondary' size='default' onClick={close}>
          {t('continue')}
        </Button>
        <Button kind='danger' size='default' onClick={onDropEditsHandler}>
            {t('discard')}
        </Button>
        <Button kind='primary' size='default' onClick={onSaveDocumentHandler}>{t('saveDocument')}</Button>
      </>
    )
  }

  return (
    <Modal
      id='modal-document-save'
      open={open}
      onRequestClose={close}
      preventCloseOnClickOutside
      modalHeading={t(
        title.key,
        title.params
      )}
      footerCustom={footerCustom()}
    >
      {t(message.key, message.params)}
    </Modal>
  )
}

export default ModalSaveDocument
